import React, { useState } from "react";
import RegisterStepOne from "../forms/RegisterStepOne";
import RegisterStepTwo from "../forms/RegisterStepTwo";
import RegisterStepThree from "../forms/RegisterStepThree";
import LeftSideLoginReg from "../elements/LeftSideLoginReg";

const Register = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const handleNextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  return (
    <div className="flex flex-row min-h-screen">
      <LeftSideLoginReg />
      {currentStep === 1 && <RegisterStepOne onNext={handleNextStep} />}
      {currentStep === 2 && <RegisterStepTwo onNext={handleNextStep} />}
      {currentStep === 3 && <RegisterStepThree />}
    </div>
  );
};

export default Register;
